import { Card } from "@/components/ui/card";
import { formatDuration } from "@/utils/format/date-time";

export const BookingDetails = ({ clinician, service }) => {
    return (
        <Card size="lg" className="flex flex-col items-stretch gap-4">
            <p className="mb-2 text-xl font-semibold">Booking summary</p>
            <div>
                <p className="text-base/5 text-neutral-500">Clinician</p>
                <p className="font-medium">
                    {clinician.firstName + " " + clinician.lastName} -{" "}
                    {clinician.professionTitle}
                </p>
            </div>
            <div>
                <p className="text-base/5 text-neutral-500">
                    Practice Location
                </p>
                <div className="flex items-center gap-1">
                    <p className="font-medium">
                        {clinician.addressTown}, {clinician.addressCounty}
                    </p>
                </div>
            </div>
            <div>
                <p className="text-base/5 text-neutral-500">Service</p>
                <p className="font-medium">{service.serviceTitle}</p>
            </div>
            <div>
                <p className="text-base/5 text-neutral-500">Duration</p>
                <p className="font-medium">
                    {formatDuration(service.appointmentLength)}
                </p>
            </div>
            <hr className="border-gray-200" />
            <div className="flex justify-between">
                <p className="text-base/6 text-neutral-500">Subtotal</p>
                <p className="font-medium">
                    £{Number(service.appointmentPrice).toFixed(2)}
                </p>
            </div>
            <div className="flex justify-between">
                <p className="text-xl/6 font-medium text-darkgreen-500">
                    Total
                </p>
                <p className="text-xl font-medium">
                    £{Number(service.appointmentPrice).toFixed(2)}
                </p>
            </div>
        </Card>
    );
};
